import React, {
  createContext,
  useContext,
  useState,
  useEffect
} from 'react';
import { deleteCookie } from 'utils/cookies';
import { connector as authenticator, storeTokens } from 'utils/graphql';

// import { createClient } from '@supabase/supabase-js';
// import getConfig from 'next/config';

// const { publicRuntimeConfig } = getConfig();
// const authenticator = createClient(
//   publicRuntimeConfig.API_URL,
//   publicRuntimeConfig.API_PUBLIC_KEY
// );

const AuthContext = createContext();

function AuthProvider ({ children }) {

  const [providerData, setProviderData] = useState({
    data: {
      isAuthenticated: false,
      loading: true,
      sub: null,
      name: '',
      nickname: '',
      picture: '',
      email: '',
      user: null
    }
  });

  const value = {
    ...providerData,
    async signOut () {
      let { error } = await authenticator.auth.signOut();
      if (error) {
        console.error(`Failed to sign out! Please try again`, error);

        if (error.toString().startsWith('AuthSessionMissingError')) {
          deleteCookie('access_token');
          deleteCookie('refresh_token');
        }
      } else {
        deleteCookie('access_token');
        deleteCookie('refresh_token');
      }
    },

    async signInWithEmail (email, pwd) {
      const { data, error } = await authenticator.auth.signInWithPassword({
        email: email,
        password: pwd,
      });
      return { data, error };
    },

    async signUpWithEmail (email, pwd, extraData = {}) {

      extraData.firstName = extraData.firstName || email.split('@')[0];
      extraData.lastName = extraData.lastName || '';
      extraData.picture = extraData.picture || '';

      const { data, error } = await authenticator.auth.signUp({
        email: email,
        password: pwd,
        options: {
          data: extraData
        }
      });
      return { data, error };
    },

    async resetPassword (email) {
      let {
        data,
        error
      } = await authenticator.auth.resetPasswordForEmail(
        email,
        {
          redirectTo: location.href,
        }
      );
      return { data, error };
    },

    setData (key, value) {
      setProviderData({
        ...value,
        data: {
          ...value.data,
          [key]: value
        }
      });
    }
  };

  useEffect(() => {
    async function setAuthStateOnChange (authState) {
      const tokens = {
        access_token: authState?.access_token,
        refresh_token: authState?.refresh_token,
      };

      await Promise.all([
        storeTokens(tokens), // will register current tokens in session and cookies
        setProviderData({
          ...providerData,
          data: {
            ...providerData.data,
            loading: false,
            isAuthenticated: !!authState?.access_token,
            user: authState?.user || null,
            ...tokens
          }
        }),
      ]);
    }

    authenticator.auth.getSession().then(({ data: { session } }) => {
      setAuthStateOnChange(session);
    });

    const {
      data: { subscription },
    } = authenticator.auth.onAuthStateChange((_event, session) => {
      setAuthStateOnChange(session);
    });

    return function onAuthProviderUnmount () {
      subscription.unsubscribe();
    };
  }, []);


  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

// this allows you to use it as a simpler hook
function useAuth () {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }

  return context;
}

export {
  AuthProvider,
  AuthContext,
  useAuth
};
